import { Component, OnInit, AfterViewInit, OnChanges, SimpleChanges, Input, ViewChild, EventEmitter, Output, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { CustomCheckBoxOptions } from './custom-checbox.interface';
import { slideDownUp } from '../global-app-animations';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-custom-checkbox',
    templateUrl: './custom-checkbox.component.html',
    styleUrls: ['./custom-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [slideDownUp],
    standalone: false
})
export class CustomCheckboxComponent implements AfterViewChecked, OnInit, AfterViewInit, OnChanges {

  @ViewChild('checkBoxEl') checkBoxEl: MatCheckbox | undefined;
  @Input() options: CustomCheckBoxOptions | undefined;
  @Input() field!: FieldConfig | undefined;
  @Input() group!: FormGroup | undefined;
  
  parsedOptions: CustomCheckBoxOptions | undefined;

  value:boolean= false
  
  // comunica cambiamento stato
  @Output() changedValue: EventEmitter<any> = new EventEmitter<any>();


  constructor(

  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    //this.checkBoxEl!.setProperties(this.group ? this.field?.options! : this.parsedOptions!);
    // imposto autofocus se serve    
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      let le = document.getElementById(this.field!.name)!.getElementsByTagName("input");
      for(let i = 0; i < le!.length; i++) {
        le[i].focus();
      }
    }*/
  }

  ngAfterViewChecked(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.group) {

    }
  }

  onChange(event:any) {
    this.changedValue.emit(event);
  }

}
